// src/bridge/uiCommandBus.ts — imports NOTHING from Phaser.
//
// DIRECTION RULE (spec §3.4): State flows scene→DOM via gameBus→subscribe→
// signals. Commands flow DOM→scene via uiCommandBus. The two are NEVER crossed.
// Only src/ui/** emits; only scenes subscribe. The DOM→Phaser-import ban stays.
//
// bfcache: scenes call resubscribeToCommands() from BOTH create() and the
// pageshow handler (bfcache restore does not re-run create()).
export type UiCommand =
  | { type: 'assist:reveal' }
  | { type: 'practice:start' }
  | { type: 'practice:exit' };

const subs = new Set<(c: UiCommand) => void>();

export const uiCommandBus = {
  subscribe(fn: (c: UiCommand) => void): () => void {
    subs.add(fn);
    return () => subs.delete(fn);
  },
  emit(c: UiCommand): void {
    for (const fn of subs) {
      try { fn(c); }
      catch (e) { console.error('[uiCommandBus]', e); }
    }
  },
};
